"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeletePointPeageMutation = exports.usePointPeageByIdQuery = exports.useGetPointPeagesQuery = exports.useAddOrUpdatePointPeageMutation = exports.PointPeageApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.PointPeageApi = (0, react_1.createApi)({
    reducerPath: "pointPeageApi",
    tagTypes: ["pointPeage", "pointPeageList", "pointPeageById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        addOrUpdatePointPeage: builder.mutation({
            invalidatesTags: ["pointPeage", "pointPeageList", "pointPeageById"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `toll-points/${id}/`,
                        method: "PUT",
                        body: data,
                    };
                }
                return {
                    url: `toll-points/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        getPointPeages: builder.query({
            providesTags: ["pointPeageList"],
            query: (query) => (0, Utils_1.QueryUrl)("toll-points", query),
        }),
        pointPeageById: builder.query({
            query: (id) => `toll-points/${id}/`,
            providesTags: ["pointPeageById"],
        }),
        deletePointPeage: builder.mutation({
            query: (id) => ({
                url: `toll-points/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["pointPeage", "pointPeageList", "pointPeageById"],
        }),
    }),
});
exports.useAddOrUpdatePointPeageMutation = exports.PointPeageApi.useAddOrUpdatePointPeageMutation, exports.useGetPointPeagesQuery = exports.PointPeageApi.useGetPointPeagesQuery, exports.usePointPeageByIdQuery = exports.PointPeageApi.usePointPeageByIdQuery, exports.useDeletePointPeageMutation = exports.PointPeageApi.useDeletePointPeageMutation;
